import { observable, action } from 'mobx';

const sidebar = {
  visible: true,

  get invisible () {
    return !this.visible;
  },

  toggle: action('TOGGLE SIDEBAR', function () {
    this.visible = !this.visible;
  }),

  hide: action('CLOSE SIDEBAR', function () {
    this.visible = false;
  }),

  show: action('SHOW SIDEBAR', function () {
    this.visible = true;
  })
};

export const createSidebarObservable = () => observable(sidebar);
